export default __webpack_public_path__ + "static/es_best_rel_pme_spring.png";